export default __webpack_public_path__ + "static/compareItemImg5-3142da600df0aba399d719d890e6a0c1.png";